import React, { useEffect, useState } from "react";
import { Row, Col, Button, Container, Card, Nav, Alert } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";
import { getFinComms } from "../../afinanceapi";
import AccountsEmailModal from "./AddEditAccountsEmail";
import { getUserPracticeById } from "../../api";
import "./Comms.css"; // we’ll add small tab & preview styles below

export function AccountsEmail({ refresh, onEmailUpdate = () => {} }) {
  const [emailData, setEmailData] = useState([]);   // at most one entry
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [practices, setPractices] = useState([]);
  const [activeTab, setActiveTab] = useState("statement"); // tabs: statement | invoice | receipt | creditNote

  const emailTypes = {
    statement:  { label: "Statement Emails" },
    invoice:    { label: "Invoice Emails" },
    receipt:    { label: "Receipt Emails" },
    creditNote: { label: "Credit Note Emails" },
  };

const loadEmailData = async () => {
  const token = sessionStorage.getItem("user");
  if (!token) return;
  const decoded = jwtDecode(token);
  const practiceNumbers = decoded.practice || [];

  const normalizedPractices = Array.isArray(practiceNumbers) ? practiceNumbers : [];
  setPractices(normalizedPractices);

  // Use practiceNumbers directly, not the practices state
  const result = await getFinComms(normalizedPractices);
  setEmailData(Array.isArray(result) ? result : []);
};

  useEffect(() => {
    loadEmailData();
  }, [refresh]);

  const handleButtonClick = () => {
    setSelectedEmail(emailData.length > 0 ? emailData[0] : null);
    setModalShow(true);
  };

  // helpers to pull subject/body by tab key
 const getSubject = (entry, type) =>
    entry?.[type]?.subject ?? entry?.[`${type}Subject`] ?? "";
  const getBody = (entry, type) =>
    entry?.[type]?.text ?? entry?.[`${type}Text`] ?? "";

  const entry = emailData[0]; // at most one config

  return (
    <Container fluid className="border-0">
      <Card className="mb-4 border-0 shadow-sm">
        <Card.Body>
         {/* Tabs + Edit in one row */}
<div className="d-flex align-items-center mb-3 gap-2 flex-wrap">
  <Nav variant="pills" className="comms-tabs flex-grow-1 overflow-auto">
    {Object.keys(emailTypes).map((type) => (
      <Nav.Item key={type}>
        <Nav.Link
          active={activeTab === type}
          onClick={() => setActiveTab(type)}
        >
          {emailTypes[type].label}
        </Nav.Link>
      </Nav.Item>
    ))}
  </Nav>

  <Button
    variant="primary"
    className="ms-auto"
    onClick={handleButtonClick}
  >
    {entry ? "Edit Email Templates" : "Add Financial Email"}
  </Button>
</div>

          {/* Tab content */}
          {!entry ? (
            <Row>
              <Col>
                <div className="text-muted">Loading Emails</div>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col lg={10} xl={9}>
                <div className="email-template-panel">
                  {/* Subject */}
                  <div className="mb-3">
                    <div className="fw-semibold">Subject</div>
                    <div className="template-field">
                      {getSubject(entry, activeTab) || <span className="text-muted">No subject specified</span>}
                    </div>
                  </div>

          

                  {/* Email body preview */}
                  <div className="mb-2 fw-semibold">Email Body</div>
                  <div
                    className="html-preview"
                    dangerouslySetInnerHTML={{
                      __html: getBody(entry, activeTab) || "<span class='text-muted'>—</span>",
                    }}
                  />
                </div>
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>

      {/* Modal */}
      <AccountsEmailModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        emailDetail={selectedEmail}
        practices={practices}
        onSmsUpdate={() => {
          setModalShow(false);
          setSelectedEmail(null);
          loadEmailData();
          onEmailUpdate();
        }}
      />
    </Container>
  );
}
